<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" class="mt-8"/>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.보호구지급대장.push({ id: Math.random().toString(36).substr(2, 9)});
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.보호구지급대장.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.보호구지급대장 = this.form.보호구지급대장.filter((row) => !row.selected);
      this.allCheck = false;
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) {
          this.form.보호구지급대장.forEach((row) => row.selected = true);
        } else {
          this.form.보호구지급대장.forEach((row) => row.selected = false);
        }
      }, 100);
    },
  },
  computed: {
    checkedSelectedItem() {
      return this.form.보호구지급대장.filter((row) => row.selected).length === 0;
    },
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 5px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
